import { render, staticRenderFns } from "./RecommendResume.vue?vue&type=template&id=fff6336a&scoped=true&"
import script from "./RecommendResume.vue?vue&type=script&lang=js&"
export * from "./RecommendResume.vue?vue&type=script&lang=js&"
import style0 from "./RecommendResume.vue?vue&type=style&index=0&id=fff6336a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff6336a",
  null
  
)

export default component.exports